import { CopyAll } from '@mui/icons-material';
import { styled } from '@mui/material';

export const CopyIconButton = styled(CopyAll)`
  color: ${({ theme }) => theme.palette.action.active};
  margin-left: ${({ theme }) => theme.spacing(0.5)};
  cursor: pointer;
`;
